import { navigate } from "gatsby";
import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { ResetPasswordImg } from "../../assets/images/index";
import { Button, InputText } from "../../components/form";
import { Container, Footer, Header } from "../../components/shared";
import { AuthService } from "../../services/profissional/auth";
import { ImageWrapper, InfoWrapper, InputWrapper, IntroWrapper, Main } from "../../styles/saude/redefinicao-senha";
import { statusActionProfessionalData } from "../../utils";
import { LoginContext } from "../../contexts/Login";


export default function RedefinicaoSenha() {
  const regexEmail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const requestEmail = new AuthService();
  const { professionalData } = useContext(LoginContext);


  const sendLink = async () => {
    const validEmail = validateEmail(email);

    if (!validEmail) return;

   try {
    await requestEmail.resetPassword({ email });

    navigate("/redefinicao-de-senha/verificar-email", { state: { email } });
   } catch (error) {
    setError("Houve um problema ao tentar enviar email. Tente novamente mais tarde!")
   }
  };

  const validateEmail = (email) => {
    setEmail(email);

    const isEmailValid = regexEmail.test(email);

    if (email && isEmailValid) {
      setError("");
      return true;
    }

    setError(
      !email ? "O campo 'Email' é obrigatório" : "Por favor, utilize um formato de e-mail válido. Por exemplo: email@dominio.com.br",
    );

    return false;
  };
  
    /**
   * Possui o fluxo de fazer uma verificação de segurança, de que se o usuário tiver realizado o login, e o token estiver armazenado no SessionStorage, ele não pode acessar diretamente esta página. 
   * Para acessar, é necessário fazer o logout.
   */
    useEffect(() => {
      const authToken = sessionStorage.getItem("authToken");
      if(authToken) navigate(statusActionProfessionalData[professionalData.status]);
    });

  return (
    <>
      <Helmet>
        <title>Redefinir Senha | Lacrei Saúde</title>
        <meta name="description" content="Página onde o profissional pode solicitar um link para redefinir a sua senha" />
      </Helmet>
      <Container>
        <Header />
        <Main>
          <InfoWrapper>
            <IntroWrapper>
              <h1>Redefinir senha</h1>
              <p>Vamos enviar um link em seu e-mail para redefinir a sua senha.</p>
            </IntroWrapper>
            <InputWrapper>
              <InputText
                label="E-mail"
                placeholder="Digite seu e-mail"
                error={error}
                onChange={(e) => {
                  validateEmail(e.target.value);
                }}
                large={false}
              />
              <Button title="Enviar link" noLink onClick={sendLink} shadowy />
              <Button title="Voltar" link="/" shadowy isVariant />
            </InputWrapper>
          </InfoWrapper>
          <ImageWrapper>
            <ResetPasswordImg role="img" alt="Pessoa segurando uma chave gigante." aria-label="Pessoa segurando uma chave gigante." className="main-image" />
            <span className="image-credits">
              Ilustrado por{" "}
              <a className="anchor-image" target="_blank" href="https://br.freepik.com/" rel="noreferrer">
                Freepik
              </a>
            </span>
          </ImageWrapper>
        </Main>
        <Footer hasButtonUp={false} />
      </Container>
    </>
  );
}
